import {
  CContainer,
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle,
} from "@coreui/react";
import { useEffect, useState } from "react";
import Errors from "../../models/errors";
import DocumentError, { newDocumentError } from "../../models/document-error";
import DocumentErrorForm from "./DocumentErrorForm";

interface DocumentErrorUpdateModalProps {
  show: boolean;
  documentError?: DocumentError;
  onCancel: () => void | Promise<void>;
  onSuccess: () => void | Promise<void>;
}

const DocumentErrorUpdateModal: React.FC<DocumentErrorUpdateModalProps> = ({
  show,
  documentError,
  onCancel,
  onSuccess,
}) => {
  const [initialErrors, setInitialErrors] = useState<Errors>({});
  const [initialDocumentError, setInitialDocumentError] =
    useState<DocumentError>(documentError ? documentError : newDocumentError());

  const modalTitle = documentError
    ? `Editar error conocido de documento #${documentError.id}`
    : `Crear nuevo error conocido de documento`;

  const onClose = () => {
    setInitialErrors({});
    setInitialDocumentError(newDocumentError());
    onCancel();
  };
  useEffect(() => {
    setInitialDocumentError(documentError ? documentError : newDocumentError());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [documentError]);

  return (
    <CModal show={show} onClose={onClose} size="xl">
      <CModalHeader closeButton>
        <CModalTitle>{modalTitle}</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CContainer fluid>
          <DocumentErrorForm
            initialDocumentError={initialDocumentError}
            initialErrors={initialErrors}
            onCancel={onCancel}
            onSuccess={onSuccess}
          />
        </CContainer>
      </CModalBody>
    </CModal>
  );
};

export default DocumentErrorUpdateModal;
